import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Venue from "../components/venue"
import Arrivare from "../components/arrivare"
import Accomodation from "../components/accomodation"
// import Newsletter from "../components/newsletter"
import Banner from "../components/banner"


const InfoPage = ({ pageContext: { locale }, location }) => (
  <Layout locale={locale} langPath={location.pathname} >
    <SEO title="info" />
    <div className="bg-fagioloni bg-fagioloni--offset">
      <div className="bg-fagioloni__left"></div>
      <div className="bg-fagioloni__right"></div>
      <Venue />
      <Arrivare />
      <Accomodation />
      <Banner />
      {/* <Newsletter /> */}
    </div>
  </Layout>
);

export default InfoPage;
